import "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/core-js/modules/es.array.iterator.js";
import "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/core-js/modules/es.promise.js";
import "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/core-js/modules/es.object.assign.js";
import "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/core-js/modules/es.promise.finally.js";
// Vue
import { createApp, h, getCurrentInstance } from 'vue';
import App from '@/App';

// 配置
import Setting from '@/setting';

// 混合
import mixinApp from '@/mixins/app';

// 插件
import plugins from '@/plugins';

// store
import store from '@/store/index';

// ViewUIPlus
import ViewUIPlus from 'view-ui-plus';

// 菜单和路由
import router from '@/router';
import menuHeader from '@/menu/header';
import { frameInRoutes } from '@/router/routes';

// 多语言
import i18n from '@/i18n';
import { loadRemoteLocaleMessages } from '@/i18n/locale';

// 内置组件
import iLink from '@/components/link';
import iSearch from '@/components/search';
import iFrame from '@/components/frame';
import iIconSelect from '@/components/icon-select/icon-select.min';
import iSidebar from '@/components/sidebar/sidebar.min';

// 使用样式，修改主题可以在 styles 目录下创建新的主题包并修改 View UI Plus 默认的 less 变量
// 参考 https://www.iviewui.com/docs/guide/theme
import './styles/index.less';
import auth from './plugins/auth/auth';
import { ConfigProvider } from 'vant';

// 全局变量
import Utils from '@/utils/index';
var app = createApp({
  mixins: [mixinApp],
  render: function render() {
    return h(App);
  },
  created: function created() {
    // 处理路由 得到每一级的路由设置
    this.$store.commit('admin/page/init', frameInRoutes);
    // 设置顶栏菜单
    if (!Setting.dynamicMenu) this.$store.commit('admin/menu/setHeader', menuHeader);
    // 加载用户登录的数据
    this.$store.dispatch('admin/account/load');
    // this.$store.dispatch('admin/account/getLoginUser',{}).catch((err) => {
    //     debugger
    //     console.log(err)
    //     this.$store.dispatch('admin/account/logout',null);
    // })

    // 初始化全屏监听
    this.$store.dispatch('admin/layout/listenFullscreen');
    // 将根实例存全局，可在特殊场景下调用
    if (window) {
      window.$app = getCurrentInstance();
      window.$app.$t = i18n.global.t;
    }
    // 加载远程 i18n
    if (Setting.i18n.remote) loadRemoteLocaleMessages(i18n);
  },
  watch: {
    // 监听路由 控制侧边栏显示 标记当前顶栏菜单（如需要）
    '$route': function $route(to, from) {
      this.$store.dispatch('admin/menu/setMenuList', to);

      // if (Setting.dynamicMenu) {
      //     if (isFirstRouteChange) {
      //         isFirstRouteChange = false;
      //         // 每次进入 app 时，获取一次菜单
      //         this.$store.dispatch('admin/menu/getMenuList', to);
      //     }
      // }

      this.appRouteChange(to, from);
    }
  }
});
app.use(router);
app.use(store);
app.use(i18n);
app.use(iIconSelect);
app.use(ViewUIPlus, {
  i18n: i18n,
  size: 'default',
  transfer: true,
  select: {
    arrow: 'md-arrow-dropdown'
  },
  tree: {
    arrow: 'md-arrow-dropright',
    arrowSize: 16
  },
  cascader: {
    arrow: 'md-arrow-dropdown',
    itemArrow: 'md-arrow-dropright'
  },
  menu: {
    arrow: 'md-arrow-dropdown'
  }
});
app.use(plugins);
app.use(ConfigProvider);
app.use(iSidebar);
app.component('i-link', iLink);
app.component('i-frame', iFrame);
app.component('i-search', iSearch);

// app.config.globalProperties.$Constant = Constant
// app.config.globalProperties.$Tool = Tool
// app.config.globalProperties.$Toast = Toast

app.config.globalProperties.$auth = auth;
app.config.globalProperties.$Utils = Utils;
app.mount('#app');